// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as YourFirstVisitRouteImport } from './routes/your-first-visit'
import { Route as WhyPatientsAreChoosingInvisalignInMiamiTopReasonsRouteImport } from './routes/why-patients-are-choosing-invisalign-in-miami-top-reasons'
import { Route as WhyChooseUsRouteImport } from './routes/why-choose-us'
import { Route as PatientsReferAFriendRouteImport } from './routes/patients-refer-a-friend'
import { Route as OurTreatmentsRouteImport } from './routes/our-treatments'
import { Route as OrthodonticsForTeensRouteImport } from './routes/orthodontics-for-teens'
import { Route as OrthodonticsForChildrenRouteImport } from './routes/orthodontics-for-children'
import { Route as OrthodonticsForAllAgesRouteImport } from './routes/orthodontics-for-all-ages'
import { Route as OrthodonticsForAdultsRouteImport } from './routes/orthodontics-for-adults'
import { Route as OfficeTourRouteImport } from './routes/office-tour'
import { Route as NewPatientsRouteImport } from './routes/new-patients'
import { Route as MetalBracesRouteImport } from './routes/metal-braces'
import { Route as MeetTheTeamRouteImport } from './routes/meet-the-team'
import { Route as MeetOurDoctorsRouteImport } from './routes/meet-our-doctors'
import { Route as KidsClubRouteImport } from './routes/kids-club'
import { Route as InvisalignMiamiFlRouteImport } from './routes/invisalign-miami-fl'
import { Route as InvisalignForTeensRouteImport } from './routes/invisalign-for-teens'
import { Route as InvisalignRouteImport } from './routes/invisalign'
import { Route as InsuranceFinancesRouteImport } from './routes/insurance-finances'
import { Route as FreeConsultRouteImport } from './routes/free-consult'
import { Route as ClearBracesRouteImport } from './routes/clear-braces'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'

const YourFirstVisitRoute = YourFirstVisitRouteImport.update({
            id: '/your-first-visit',path: '/your-first-visit',getParentRoute: () => rootRouteImport
          })
const WhyPatientsAreChoosingInvisalignInMiamiTopReasonsRoute = WhyPatientsAreChoosingInvisalignInMiamiTopReasonsRouteImport.update({
            id: '/why-patients-are-choosing-invisalign-in-miami-top-reasons',path: '/why-patients-are-choosing-invisalign-in-miami-top-reasons',getParentRoute: () => rootRouteImport
          })
const WhyChooseUsRoute = WhyChooseUsRouteImport.update({
            id: '/why-choose-us',path: '/why-choose-us',getParentRoute: () => rootRouteImport
          })
const PatientsReferAFriendRoute = PatientsReferAFriendRouteImport.update({
            id: '/patients-refer-a-friend',path: '/patients-refer-a-friend',getParentRoute: () => rootRouteImport
          })
const OurTreatmentsRoute = OurTreatmentsRouteImport.update({
            id: '/our-treatments',path: '/our-treatments',getParentRoute: () => rootRouteImport
          })
const OrthodonticsForTeensRoute = OrthodonticsForTeensRouteImport.update({
            id: '/orthodontics-for-teens',path: '/orthodontics-for-teens',getParentRoute: () => rootRouteImport
          })
const OrthodonticsForChildrenRoute = OrthodonticsForChildrenRouteImport.update({
            id: '/orthodontics-for-children',path: '/orthodontics-for-children',getParentRoute: () => rootRouteImport
          })
const OrthodonticsForAllAgesRoute = OrthodonticsForAllAgesRouteImport.update({
            id: '/orthodontics-for-all-ages',path: '/orthodontics-for-all-ages',getParentRoute: () => rootRouteImport
          })
const OrthodonticsForAdultsRoute = OrthodonticsForAdultsRouteImport.update({
            id: '/orthodontics-for-adults',path: '/orthodontics-for-adults',getParentRoute: () => rootRouteImport
          })
const OfficeTourRoute = OfficeTourRouteImport.update({
            id: '/office-tour',path: '/office-tour',getParentRoute: () => rootRouteImport
          })
const NewPatientsRoute = NewPatientsRouteImport.update({
            id: '/new-patients',path: '/new-patients',getParentRoute: () => rootRouteImport
          })
const MetalBracesRoute = MetalBracesRouteImport.update({
            id: '/metal-braces',path: '/metal-braces',getParentRoute: () => rootRouteImport
          })
const MeetTheTeamRoute = MeetTheTeamRouteImport.update({
            id: '/meet-the-team',path: '/meet-the-team',getParentRoute: () => rootRouteImport
          })
const MeetOurDoctorsRoute = MeetOurDoctorsRouteImport.update({
            id: '/meet-our-doctors',path: '/meet-our-doctors',getParentRoute: () => rootRouteImport
          })
const KidsClubRoute = KidsClubRouteImport.update({
            id: '/kids-club',path: '/kids-club',getParentRoute: () => rootRouteImport
          })
const InvisalignMiamiFlRoute = InvisalignMiamiFlRouteImport.update({
            id: '/invisalign-miami-fl',path: '/invisalign-miami-fl',getParentRoute: () => rootRouteImport
          })
const InvisalignForTeensRoute = InvisalignForTeensRouteImport.update({
            id: '/invisalign-for-teens',path: '/invisalign-for-teens',getParentRoute: () => rootRouteImport
          })
const InvisalignRoute = InvisalignRouteImport.update({
            id: '/invisalign',path: '/invisalign',getParentRoute: () => rootRouteImport
          })
const InsuranceFinancesRoute = InsuranceFinancesRouteImport.update({
            id: '/insurance-finances',path: '/insurance-finances',getParentRoute: () => rootRouteImport
          })
const FreeConsultRoute = FreeConsultRouteImport.update({
            id: '/free-consult',path: '/free-consult',getParentRoute: () => rootRouteImport
          })
const ClearBracesRoute = ClearBracesRouteImport.update({
            id: '/clear-braces',path: '/clear-braces',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AboutUsRoute: AboutUsRoute,ClearBracesRoute: ClearBracesRoute,FreeConsultRoute: FreeConsultRoute,InsuranceFinancesRoute: InsuranceFinancesRoute,InvisalignRoute: InvisalignRoute,InvisalignForTeensRoute: InvisalignForTeensRoute,InvisalignMiamiFlRoute: InvisalignMiamiFlRoute,KidsClubRoute: KidsClubRoute,MeetOurDoctorsRoute: MeetOurDoctorsRoute,MeetTheTeamRoute: MeetTheTeamRoute,MetalBracesRoute: MetalBracesRoute,NewPatientsRoute: NewPatientsRoute,OfficeTourRoute: OfficeTourRoute,OrthodonticsForAdultsRoute: OrthodonticsForAdultsRoute,OrthodonticsForAllAgesRoute: OrthodonticsForAllAgesRoute,OrthodonticsForChildrenRoute: OrthodonticsForChildrenRoute,OrthodonticsForTeensRoute: OrthodonticsForTeensRoute,OurTreatmentsRoute: OurTreatmentsRoute,PatientsReferAFriendRoute: PatientsReferAFriendRoute,WhyChooseUsRoute: WhyChooseUsRoute,WhyPatientsAreChoosingInvisalignInMiamiTopReasonsRoute: WhyPatientsAreChoosingInvisalignInMiamiTopReasonsRoute,YourFirstVisitRoute: YourFirstVisitRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)